import amplitude from 'amplitude-js'
import { UserEvents } from './constants'

const amplitudeEvent = userEvent => amplitude.getInstance().logEvent(userEvent)

export { amplitudeEvent, UserEvents }
